import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { CompliantDropdownOptions } from "../../utils/Utils";

export const IsCompliantDropdown = ({ value, isMulti = false, isShowAll = true, onSelect, placeholder, ...props }) => {
  const [list, setList] = useState();

  useEffect(() => {
    return () => {
      setList();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isShowAll) {
      const allOption = { id: 0, label: "All Compliance", value: "" };
      setList([allOption, ...CompliantDropdownOptions]);
    } else {
      setList(CompliantDropdownOptions);
    }
  }, [isShowAll]);

  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? (isShowAll ? (list ? list[0] : null) : null)}
      onChange={(e) => {
        onSelect(e);
      }}
      {...props}
    />
  );
};
